const isDefined = require('../is-defined')
const isValidDate = require('./is-valid-date')
/**
 * Check if current date is between two given dates
 * @param {Object} [options] - Options
 * @param {Date} [options.start] - Start date
 * @param {Date} [options.end] - End date
 * @returns {boolean}
 */
const todayIsBetweenDates = options => {
  const { start, end } = options
  const todayDateTime = new Date().getTime()

  if (isDefined(start)) {
    const startDateTime = isValidDate(start) ? start.getTime() : new Date(start).getTime()
    if (isNaN(startDateTime) || startDateTime >= todayDateTime) {
      return false
    }
  }

  if (isDefined(end)) {
    const endDateTime = isValidDate(end) ? end.getTime() : new Date(end).getTime()
    if (isNaN(endDateTime) || endDateTime <= todayDateTime) {
      return false
    }
  }

  return true
}

module.exports = todayIsBetweenDates
